<div class="row p-3">
  <div class="col-sm-12 col-md-12 col-lg-12">
    <form [formGroup]="signupForm" novalidate>
      <div class="mb-3">
        <div class="form-group form-phone mb-3">
          <div>
            <label for="country" class="form-label">País</label>
            <select
              class="form-select"
              id="country"
              formControlName="country"
              [ngClass]="{
                'is-invalid': signupForm.get('country')?.invalid && signupForm.get('country')?.touched,
              }">
              @for (country of countriesList; track country.acronym) {
                <option [value]="country.acronym">{{ country.name }}</option>
              }
            </select>
          </div>

          <!-- DDI -->
          <div>
            <label for="ddi" class="form-label">DDI</label>
            <app-ddi-select formControlName="ddi"></app-ddi-select>
          </div>

          <!-- Celular -->
          <div class="flex-grow-1">
            <label for="phone" class="form-label">Celular</label>
            <input
              type="phone"
              class="form-control"
              id="phone"
              formControlName="phone"
              inputmode="numeric"
              placeholder="(00) 00000-0000"
              [mask]="controls.ddi.value === '+55' ? '(00) 00000-0000' : ''"
              [ngClass]="{
                'is-invalid': signupForm.get('phone')?.invalid && signupForm.get('phone')?.touched,
              }" />
            @if (signupForm.get("phone")?.invalid && signupForm.get("phone")?.touched) {
              <div class="invalid-feedback">
                @if (signupForm.get("phone")?.errors?.["required"]) {
                  <span> Campo Telefone não pode estar vazio </span>
                }
                @if (signupForm.get("phone")?.errors?.["invalidPhoneNumber"]) {
                  <span> O campo telefone deve conter somente numeros </span>
                }
              </div>
            }
          </div>
        </div>

        <!-- EMAIL -->
        <div class="mb-3">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form-control"
            placeholder="ex: nome@gmail.com"
            [readonly]="tokenPayload?.email"
            [ngClass]="{
              'is-invalid': signupForm.get('email')?.invalid && signupForm.get('email')?.touched,
            }" />
          @if (signupForm.get("email")?.invalid && signupForm.get("email")?.touched) {
            <div class="invalid-feedback">
              @if (signupForm.get("email")?.errors?.["required"]) {
                <span> O campo de e-mail é obrigatório. </span>
              }
              @if (signupForm.get("email")?.errors?.["email"]) {
                <span> Formato de e-mail inválido. </span>
              }
            </div>
          }
        </div>

        <!-- SENHAS (apenas para novo cadastro) -->
        @if (!userData) {
          <div class="form-group-columns">
            <div class="mb-3">
              <label for="password" class="form-label">Senha</label>
              <div class="input-group">
                <input
                  [type]="hidePassword ? 'password' : 'text'"
                  class="form-control"
                  id="password"
                  formControlName="password"
                  placeholder="com mais de 6 caracteres"
                  [ngClass]="{
                    'is-invalid': signupForm.get('password')?.invalid && signupForm.get('password')?.touched,
                  }" />
                <button class="btn btn-outline-secondary" type="button" (click)="hidePassword = !hidePassword">
                  @if (hidePassword) {
                    <i class="pi pi-eye"></i>
                  } @else {
                    <i class="pi pi-eye-slash"></i>
                  }
                </button>
                @if (signupForm.get("password")?.invalid && signupForm.get("password")?.touched) {
                  <div class="invalid-feedback">
                    @if (signupForm.get("password")?.errors?.["required"]) {
                      <span> A senha é obrigatória. </span>
                    }
                    @if (signupForm.get("password")?.errors?.["minlength"]) {
                      <span> A senha deve ter no mínimo 6 caracteres. </span>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="mb-3">
              <label for="confirmPassword" class="form-label">Confirmar Senha</label>
              <div class="input-group">
                <input
                  [type]="hideConfirm ? 'password' : 'text'"
                  id="confirmPassword"
                  formControlName="confirmPassword"
                  class="form-control"
                  placeholder="Confirme sua nova senha"
                  [ngClass]="{ 'is-invalid': isConfirmPasswordInvalid }" />
                <button class="btn btn-outline-secondary" type="button" (click)="hideConfirm = !hideConfirm">
                  @if (hideConfirm) {
                    <i class="pi pi-eye"></i>
                  } @else {
                    <i class="pi pi-eye-slash"></i>
                  }
                </button>

                @if (signupForm.get("confirmPassword")?.touched && signupForm.get("confirmPassword")?.invalid) {
                  <div class="invalid-feedback">A confirmação de senha deve ser preenchida</div>
                }
                @if (signupForm.get("confirmPassword")?.touched && signupForm.hasError("passwordsMismatch")) {
                  <div class="invalid-feedback">As senhas devem ser iguais.</div>
                }
              </div>
            </div>
          </div>
        }

        <!-- DADOS PESSOAIS -->
        <div class="mb-3">
          <label for="name" class="form-label">Nome Completo</label>
          <input
            type="text"
            class="form-control"
            id="name"
            placeholder="Nome e Sobrenome"
            formControlName="name"
            [ngClass]="{
              'is-invalid': signupForm.get('name')?.invalid && signupForm.get('name')?.touched,
            }" />
          @if (signupForm.get("name")?.invalid && signupForm.get("name")?.touched) {
            <div class="invalid-feedback">
              @if (signupForm.get("name")?.errors?.["required"]) {
                <span> Campo nome completo esta vazio </span>
              }
              @if (signupForm.get("name")?.errors?.["invalidName"]) {
                <span> Você deve inserir nome e sobrenome </span>
              }
              @if (signupForm.get("name")?.errors?.["minlength"]) {
                <span> Nome muito pequeno </span>
              }
            </div>
          }
        </div>

        <!-- Documento (depende do país) -->
        @if (isBrazilianCostumer) {
          <div class="mb-3">
            <label for="cpf" class="form-label">CPF</label>
            <input
              type="text"
              class="form-control"
              id="cpf"
              placeholder="CPF"
              formControlName="cpf"
              mask="000.000.000-00"
              [ngClass]="{
                'is-invalid': signupForm.get('cpf')?.invalid && signupForm.get('cpf')?.touched,
              }" />
            @if (signupForm.get("cpf")?.invalid && signupForm.get("cpf")?.touched) {
              <div class="invalid-feedback">
                @if (signupForm.get("cpf")?.errors?.["required"]) {
                  <span> Campo CPF está vazio </span>
                }
                @if (signupForm.get("cpf")?.errors?.["cpfInvalid"]) {
                  <span> CPF inválido </span>
                }
              </div>
            }
          </div>
        } @else {
          <div class="mb-3">
            <label for="identity_card" class="form-label">Documento de identidade (estrangeiro)</label>
            <input
              type="text"
              class="form-control"
              id="identity_card"
              placeholder="passaporte, DNI, RNE…"
              formControlName="identity_card"
              [ngClass]="{
                'is-invalid': signupForm.get('identity_card')?.invalid && signupForm.get('identity_card')?.touched,
              }" />
            @if (signupForm.get("identity_card")?.invalid && signupForm.get("identity_card")?.touched) {
              <div class="invalid-feedback">
                @if (signupForm.get("identity_card")?.errors?.["required"]) {
                  <span> Campo de documento internacional está vazio </span>
                }
              </div>
            }
          </div>
        }

        <!-- ENDEREÇO -->
        <div class="row mb-3">
          <div class="col-6">
            <label for="postal_code" class="form-label">CEP/Código Postal</label>

            <div class="position-relative">
              <input
                type="text"
                class="form-control pe-5"
                id="postal_code"
                formControlName="postal_code"
                placeholder="00000-000"
                [mask]="isBrazilianCostumer ? '00000-000' : null"
                [readonly]="isLoadingCep"
                [class.loading-field]="isLoadingCep"
                [class.is-invalid]="signupForm.get('postal_code')?.invalid && signupForm.get('postal_code')?.touched" />

              @if (isLoadingCep) {
                <div class="position-absolute top-50 end-0 translate-middle-y pe-2 input-spinner">
                  <div class="spinner-border spinner-border-sm text-secondary" role="status">
                    <span class="visually-hidden">Carregando...</span>
                  </div>
                </div>
              }
            </div>

            @if (signupForm.get("postal_code")?.invalid && signupForm.get("postal_code")?.touched) {
              <div class="invalid-feedback">O campo CEP é obrigatório.</div>
            }
          </div>

          <div class="col-6">
            <label for="state" class="form-label">Estado</label>

            @if (isBrazilianCostumer) {
              @if (isLoadingCep) {
                <input
                  type="string"
                  id="state"
                  formControlName="state"
                  class="form-control"
                  placeholder="Informe as siglas do Estado"
                  [readonly]="isLoadingCep"
                  [class.loading-field]="isLoadingCep"
                  [class.is-invalid]="signupForm.get('state')?.invalid && signupForm.get('state')?.touched" />
              } @else {
                <select
                  class="form-select"
                  id="state"
                  formControlName="state"
                  [class.is-invalid]="signupForm.get('state')?.invalid && signupForm.get('state')?.touched">
                  <option [value]="null" disabled>Selecione um estado</option>
                  @for (state of statesOptions; track state.code) {
                    <option [value]="state.shortCode">{{ state.name }}</option>
                  }
                </select>
              }
            } @else {
              <select
                class="form-select"
                id="state"
                formControlName="state"
                [class.is-invalid]="signupForm.get('state')?.invalid && signupForm.get('state')?.touched">
                <option [value]="null" disabled>Selecione um estado</option>
                @for (state of statesOptions; track state.code) {
                  <option [value]="state.code">{{ state.name }}</option>
                }
              </select>
            }
            <div class="invalid-feedback">
              @if (signupForm.get("state")?.hasError("required")) {
                Informe um estado
              } @else if (signupForm.get("state")?.hasError("maxlength")) {
                O estado só pode ter no máximo 6 digitos.
              }
            </div>
          </div>
        </div>
        @if (isLoadingCep) {
          <div id="cepHelp" class="form-text alert alert-info">Buscando dados de endereço do CEP fornecido.</div>
        }

        <div class="form-group form-group-columns">
          <div class="mb-3 flex-grow-1">
            <label for="city_name" class="form-label">Cidade</label>
            <input
              type="text"
              class="form-control"
              id="city_name"
              formControlName="city_name"
              placeholder="Digite a cidade"
              [readonly]="isLoadingCep"
              [class.loading-field]="isLoadingCep"
              [class.is-invalid]="signupForm.get('city_name')?.invalid && signupForm.get('city_name')?.touched" />
            <div class="invalid-feedback">O campo de cidade é obrigatório e aceita somente letras.</div>
          </div>

          <div class="mb-3" style="min-width: 240px">
            <label for="district" class="form-label">Bairro/Distrito</label>
            <input
              type="text"
              class="form-control"
              id="district"
              formControlName="district"
              placeholder="Digite o bairro"
              [readonly]="isLoadingCep"
              [class.loading-field]="isLoadingCep"
              [class.is-invalid]="signupForm.get('district')?.invalid && signupForm.get('district')?.touched" />
            @if (signupForm.get("district")?.invalid && signupForm.get("district")?.touched) {
              <div class="invalid-feedback">O campo bairro é obrigatório.</div>
            }
          </div>
        </div>

        <div class="mb-3">
          <label for="street" class="form-label">Rua</label>
          <input
            type="text"
            class="form-control"
            id="street"
            formControlName="street"
            placeholder="Digite o nome da rua"
            [readonly]="isLoadingCep"
            [class.loading-field]="isLoadingCep"
            [class.is-invalid]="signupForm.get('street')?.invalid && signupForm.get('street')?.touched" />
          @if (signupForm.get("street")?.invalid && signupForm.get("street")?.touched) {
            <div class="invalid-feedback">O campo rua é obrigatório.</div>
          }
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <label for="number" class="form-label">Número</label>
            <input
              type="text"
              class="form-control"
              id="number"
              formControlName="number"
              placeholder="123"
              [class.is-invalid]="signupForm.get('number')?.invalid && signupForm.get('number')?.touched" />
            @if (signupForm.get("number")?.invalid && signupForm.get("number")?.touched) {
              <div class="invalid-feedback">O campo número é obrigatório.</div>
            }
          </div>
          <div class="col-6">
            <label for="additional_information" class="form-label">Complemento</label>
            <input
              type="text"
              class="form-control"
              id="additional_information"
              formControlName="additional_information"
              placeholder="Apt, casa, etc."
              [readonly]="isLoadingCep"
              [class.loading-field]="isLoadingCep" />
          </div>
        </div>
      </div>
    </form>

    <div class="mb-2">
      <app-button type="button" class="w-100" styleType="secondary" (btnClick)="onSubmit()" [disabled]="isLoading">
        {{ userData ? "Atualizar cadastro" : "Finalizar cadastro" }}
      </app-button>
    </div>

    @if (!userData) {
      <div class="footer-signup-terms">
        <p>
          Ao me cadastrar, concordo com os
          <span
            ><strong><a href="/terms-of-use">Termos de Uso</a></strong> e
            <strong><a href="/privacy-policy">Políticas de Privacidade</a></strong></span
          >
        </p>
      </div>
    }
  </div>
</div>
